<template>
  <footer id="foot">

    <div class="brand" ref="brand">
      <img src="../assets/logo.svg" alt="logo">
      <p class="updated">Natanael Abad - 2023</p>
      <div class="media">
        <a href="https://github.com/Nethanzel" target="_blank"><img src="../assets/icons/githubb.png" alt="github"></a>
        <a href="https://www.linkedin.com/in/natanael-abad-136404176" target="_blank"><img src="../assets/icons/linkend.png" alt="linkedin"></a>
        <!-- <a href="https://facebook.com/natanaelabaad" target="_blank"><img src="../assets/icons/facebook.png" alt="facebook"></a> -->
      </div>
    </div>
    
  </footer>
</template>

<script lang="js">

  export default {
    methods: {

    }
  }

</script>

<style lang="scss" scoped>

#foot {
  //margin: 50px auto auto auto;
  padding: 5px 0;
  width: 99%;
  height: auto;
  display: grid;
  grid-template-rows: 1;
  grid-template-columns: 2;
  grid-template-areas: 'ga1 ga1';
}
.brand {
  grid-area: ga1;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;

  img {
    margin-bottom: 2px;
    height: 25px;
    width: auto;
    object-fit: cover;
  }
  p {
    font-size: 11px;
    margin-top: 5px;
  }
}

a {
  color: #fff;
  margin-bottom: 10px;
  padding: 0px 0px;
  margin-left: 35px;
  text-decoration: none;
  span {
    color: #000;
    background: #fff;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    padding: 2px 5px;
  }
}

p {
  color: #fff;
  cursor: default;
  margin-bottom: 10px;
  font-size: 19px;
}

.updated {
  font-size: 12px;
  margin: 0;
}

.media {
  margin-top: 7px;

  a {
    padding: 0px 0px;
    margin: 0 10px;
  }
  img {
    height: 19px;
    object-fit: cover;
    margin: 0;
    padding: 0;
  }

  a:hover img {
    filter: invert(.6);
  }
}

 @keyframes showUp {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media screen and (max-width: 1370px) {
  #foot {
    margin: 20px auto auto auto;
  }

  a {
    margin-bottom: 4px;
    margin-left: 20px;
    span {
      font-size: 12px;
    }
  }

  p {
    margin-bottom: 7px;
    font-size: 16px;
  }

  .brand {
/*     img {
      height: 35px;
    } */
    p {
      font-size: 12px;
    }
  }

  .media {
    margin-top: 4px;
    a {
      padding: 0px 0px;
    }
    img {
      height: 20px;
    }
  }
}

@media screen and (max-width: 805px) {
  #foot {
    margin: 20px auto auto auto;
    padding-bottom: 50px;
    width: 98%;
  }
}

@media screen and (max-width: 680px) {
  #foot {
    grid-template-rows: 3;
    grid-template-columns: 1;
    grid-template-areas: 'ga3'
                         'ga2'
                         'ga1';
  }
  .brand {
    grid-area: ga1;
    margin-top: 25px;
  }

  a {
    margin-bottom: 10px;
    margin-left: 0px;
    span {
      font-size: 14px;
    }
  }
}

</style>